export default {
  'calander.guide': 'راهنمای تقویم',
  'calander.redtheme': 'رنگ قرمز',
  'calander.graytheme': 'رنگ طوسی',
  'calander.greentheme': 'رنگ سبز',
  'calander.bluetheme': 'رنگ آبی',
  'calander.guidetitle': 'رنگ های مناسبت های زیر تقویم به شرح زیر می باشند .',
  'calander.redthemeguide':
    'این رنگ نشانگر تعطیلات رسمی طبق کشور انتخاب شده می باشد .',
  'calander.graythemeguide':
    'این رنگ نشانگر مناسبت های دینی کشور انتخاب شده می باشد .',
  'calander.greenthemeguide':
    'این رنگ نشانگر مناسبت های بومی کشور انتخاب شده می باشد .',
  'calander.bluethemeguide':
    'این رنگ نشانگر مناسبت محلی مرسوم کشور انتخاب شده می باشد .',
  'calander.selectCountry': 'نام کشور جهت نمایش رویدادها',
  'calander.changeDate': 'تبدیل تاریخ',
  'calander.changeType': 'نوع تبدیل',
  'calander.shamsi': 'خورشیدی',
  'calander.miladi': 'میلادی',
  'calander.hijri': 'قمری',
  'calendar.calculateDate': 'محاسبات زمانی',
  'otheroption.otheroptions': 'سایر امکانات',
  'otheroption.departuredate': 'تاریخ رفت',
  'otheroption.returndate': 'تاریخ برگشت',
  'otheroption.dayscount': 'تعداد روز',
  'otheroption.calculate': 'محاسبه',
  'otheroption.timeinterval': 'فاصله زمانی (سن)',
  'otheroption.alertinsertresult': ' تاریخ وارد شده نامعتبر است.',
  'otheroption.untiltodayfuture': 'از امروز مانده است.',
  'otheroption.untiltodaypast': 'تا به امروز گذشته است.',
  'otheroption.otheroptionsguide1':
    'از طریق انتخاب کشور در قسمت بالای تقویم ، مناسبت های مختص به آن کشور روی تقویم تنظیم می گردد.',
  'otheroption.otheroptionsguide2':
    'با قرار گیری نشانگر بر روی روز ، در صورت داشتن مناسبتی ، در قسمت پایین تقویم نشان داده می شود.',
  'otheroption.otheroptionsguide3':
    'با کلیک کردن دو تاریخ، فاصله زمانی بین آنها نمایش داده می شود.',
  'otheroption.otheroptionsguide4':
    'تمامی مناسبت های تقویم، در قسمت رویداد های تقویم به صورت لیست ارایه شده است.',
};
